import { createAsyncAction } from 'redux-promise-middleware-actions';
import api from '../Api/apiIS';
import { getActionTypesResult } from '../utils';

export const licensesClassifierConstants = {
    PRODUCT_NAME_LOADED: 'PRODUCT_NAME_LOADED',
    PRODUCT_NAME_CREATED: 'PRODUCT_NAME_CREATED',
    PRODUCT_NAME_UPDATED: 'PRODUCT_NAME_UPDATED',
    PRODUCT_NAME_DELETED: 'PRODUCT_NAME_DELETED',
    PRODUCT_VERSION_LOADED: 'PRODUCT_VERSION_LOADED',
    PRODUCT_VERSION_CREATED: 'PRODUCT_VERSION_CREATED',
    PRODUCT_VERSION_UPDATED: 'PRODUCT_VERSION_UPDATED',
    PRODUCT_VERSION_DELETED: 'PRODUCT_VERSION_DELETED',
    PRODUCT_ATTRIBUTE_LOADED: 'PRODUCT_ATTRIBUTE_LOADED',
    PRODUCT_ATTRIBUTE_CREATED: 'PRODUCT_ATTRIBUTE_CREATED',
    PRODUCT_ATTRIBUTE_UPDATED: 'PRODUCT_ATTRIBUTE_UPDATED',
    PRODUCT_ATTRIBUTE_DELETED: 'PRODUCT_ATTRIBUTE_DELETED',
};

export const licensesClassifierFulfilledConstants = getActionTypesResult(licensesClassifierConstants, '_FULFILLED');
export const licensesClassifierPendingConstants = getActionTypesResult(licensesClassifierConstants, '_PENDING');
export const licensesClassifierRejectedConstants = getActionTypesResult(licensesClassifierConstants, '_REJECTED');

export const fetchLicenseProductNames = createAsyncAction(licensesClassifierConstants.PRODUCT_NAME_LOADED, () =>
    api.get('licenseProductName').then(res => res.data)
);

export const saveLicenseProductName =
    createAsyncAction(licensesClassifierConstants.PRODUCT_NAME_CREATED, productName =>
        api.post('licenseProductName', productName).then(res => res.data)
    );

export const updateLicenseProductName =
    createAsyncAction(licensesClassifierConstants.PRODUCT_NAME_UPDATED, productName =>
        api.put('licenseProductName', productName).then(res => res.data)
    );

export const deleteLicenseProductName =
    createAsyncAction(licensesClassifierConstants.PRODUCT_NAME_DELETED, productName =>
        api.delete(`licenseProductName/${productName.id}`).then(() => productName.id)
    );

export const fetchLicenseProductVersion = createAsyncAction(licensesClassifierConstants.PRODUCT_VERSION_LOADED, () =>
    api.get('licenseProductVersion').then(res => res.data)
);

export const saveLicenseProductVersion =
    createAsyncAction(licensesClassifierConstants.PRODUCT_VERSION_CREATED, productVersion =>
        api.post('licenseProductVersion', productVersion).then(res => res.data)
    );

export const updateLicenseProductVersion =
    createAsyncAction(licensesClassifierConstants.PRODUCT_VERSION_UPDATED, productVersion =>
        api.put('licenseProductVersion', productVersion).then(res => res.data)
    );

export const deleteLicenseProductVersion =
    createAsyncAction(licensesClassifierConstants.PRODUCT_VERSION_DELETED, productVersion =>
        api.delete(`licenseProductVersion/${productVersion.id}`).then(() => productVersion.id)
    );

export const fetchLicenseProductAttributes =
    createAsyncAction(licensesClassifierConstants.PRODUCT_ATTRIBUTE_LOADED, () =>
        api.get('/licenseProductAttribute').then(res => res.data)
    );

export const saveLicenseProductAttribute =
    createAsyncAction(licensesClassifierConstants.PRODUCT_ATTRIBUTE_CREATED, productAttribute =>
        api.post('/licenseProductAttribute', productAttribute).then(res => res.data)
    );

export const updateLicenseProductAttribute =
    createAsyncAction(licensesClassifierConstants.PRODUCT_ATTRIBUTE_UPDATED, productAttribute =>
        api.put('/licenseProductAttribute', productAttribute).then(res => res.data)
    );

export const deleteLicenseProductAttribute =
    createAsyncAction(licensesClassifierConstants.PRODUCT_ATTRIBUTE_DELETED, productAttribute =>
        api.delete(`/licenseProductAttribute/${productAttribute.id}`).then(() => productAttribute.id)
    );
